import { createFileRoute, redirect } from '@tanstack/react-router'
import { withRoutePermissions } from '~/utils/rbac'

// Chaque onglet est une URL distincte ; /users redirige vers l'onglet par défaut
// (« Utilisateurs de l'app ») directement au chargement de la route.
export const Route = createFileRoute('/_authenticated/users/')({
  staticData: {
    permission: ['read', 'users'],
  },
  beforeLoad: () => {
    throw redirect({ to: '/users/app' })
  },
})
withRoutePermissions(Route)
